
import PadletLogo, { LogoType } from 'vuecomponents/PadletLogo.vue'
import SurfaceTitle from 'vuecomponents/SurfaceTitle.vue'
import AppBarAccountAvatar from 'vuecomponents/AppBarAccountAvatar.vue'
import SurfaceActivityIndicator from 'vuecomponents/surface-activity-indicator.vue'
import SurfaceFilterDropdownButton from 'vuecomponents/SurfaceFilterDropdownButton.vue'
import SurfaceNav from 'vuecomponents/SurfaceNav.vue'
import SurfaceTitleOld from 'vuecomponents/surface_title.vue'
import OzIconButton from 'library/v4/components/OzIconButton.vue'
import { Component, Vue } from 'vue-property-decorator'
import { State, Getter, Action, namespace } from 'vuex-class'
import type { User } from 'types'
import SurfaceHeaderMobile from 'vuecomponents/SurfaceHeaderMobile.vue'

@Component({
  components: {
    OzIconButton,
    PadletLogo,
    SurfaceNav,
    SurfaceTitleOld,
    AppBarAccountAvatar,
    SurfaceActivityIndicator,
    SurfaceFilterDropdownButton,
    SurfaceTitle,
    SurfaceHeaderMobile,
  },
})
export default class SurfaceHeader extends Vue {
  $el!: HTMLDivElement
  $refs!: {
    surfaceHeaderMobile: SurfaceHeaderMobile
  }

  @State isEmbedded!: boolean
  @State isElectronApp!: boolean
  @State xHeader!: boolean
  @State user!: User
  @Getter dir!: 'ltr' | 'rtl'
  @Getter backgroundColor!: string
  @Getter headerColor!: string
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter isMap!: boolean
  @Getter amIRegistered!: boolean
  @Getter homeUrl!: string
  @Getter isTitleBarTransparent!: boolean
  @Getter xDesktopSurfaceLayoutV3!: boolean
  @Getter xMobileSurfaceLayoutV3!: boolean
  @Getter canIAdminister!: boolean
  @Getter canFilterPosts!: boolean
  @Action resizeHeader!: (props: { height: number }) => void
  @Action checkAndSubscribeToPushNotifications!: () => void
  @namespace('settings').Action toggleSettingsPanel!: () => void

  get logoType(): LogoType {
    if (this.isMap) {
      return this.colorScheme === 'light' ? LogoType.Dark300 : LogoType.Light300
    }
    return this.backgroundLuminance === 'light' ? LogoType.Dark300 : LogoType.Light300
  }

  get realBackgroundLuminance(): 'light' | 'dark' {
    if (this.isMap) {
      return this.colorScheme
    }
    return this.backgroundLuminance
  }

  mounted(): void {
    // Don't prompt for notifications if the user is not registered and the app is not the electron app
    if (this.amIRegistered && !this.isElectronApp) this.checkAndSubscribeToPushNotifications()

    this.updateHeaderHeight()
    window.addEventListener('resize', this.updateHeaderHeight)
  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.updateHeaderHeight)
  }

  updateHeaderHeight(): void {
    if (this.xDesktopSurfaceLayoutV3) {
      this.$nextTick(() => {
        this.resizeHeader({ height: this.$el.offsetHeight })
      })
    }
  }

  collapse(): void {
    if (!this.$refs.surfaceHeaderMobile) return
    this.$refs.surfaceHeaderMobile.collapse()
  }
}
